import "core-js/modules/es6.string.small";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import times from 'lodash/times';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'ArticleImage',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _this = this;

      return {
        images: times(this.payload.items.length, Number).map(function (i) {
          var _ref, _ref2, _ref3, _ref4;

          return {
            alt: ((_ref4 = _this.payload) != null ? (_ref4 = _ref4.items) != null ? (_ref4 = _ref4[i]) != null ? (_ref4 = _ref4.images) != null ? _ref4.alt : _ref4 : _ref4 : _ref4 : _ref4) || '',
            url: formatPrismicImage((_ref3 = _this.payload) != null ? (_ref3 = _ref3.items) != null ? (_ref3 = _ref3[i]) != null ? (_ref3 = _ref3.images) != null ? _ref3.url : _ref3 : _ref3 : _ref3 : _ref3) || EMPTY_PIXEL,
            small: formatPrismicImage((_ref2 = _this.payload) != null ? (_ref2 = _ref2.items) != null ? (_ref2 = _ref2[i]) != null ? (_ref2 = _ref2.images) != null ? (_ref2 = _ref2.small) != null ? _ref2.url : _ref2 : _ref2 : _ref2 : _ref2 : _ref2) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref = _this.payload) != null ? (_ref = _ref.items) != null ? (_ref = _ref[i]) != null ? (_ref = _ref.images) != null ? (_ref = _ref.large) != null ? _ref.url : _ref : _ref : _ref : _ref : _ref) || EMPTY_PIXEL
          };
        })
      };
    }
  }
};